module.exports = __webpack_public_path__ + "img/PL09063.5f7014da.png";